<template>
  <CRow class="stat-cards-row">
    <CCol>
      <CCard class="stat-card stat-card-primary">
        <CCardBody class="text-center">
          <div class="stat-number">{{ get_currency(info.today_visit) }}</div>
          <div class="stat-label">{{ $t('today_visit') }}</div>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol>
      <CCard class="stat-card stat-card-info">
        <CCardBody class="text-center">
          <div class="stat-number">{{ get_currency(info.tomorrow_reserve) }}</div>
          <div class="stat-label">{{ $t('tomorrow_visit') }}</div>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol v-if="$i18n.locale=='fa'">
      <CCard class="stat-card stat-card-danger">
        <CCardBody class="text-center">
          <div class="stat-number">{{ info.sms_credit.toString() }}</div>
          <div class="stat-label">{{ $t('sms_credit') }}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'WidgetsDropdown',
  props:{
    info:Object,
  }
}
</script>

<style scoped>
.stat-cards-row {
  margin-left: -10px;
  margin-right: -10px;
}

.stat-cards-row > * {
  padding-left: 10px;
  padding-right: 10px;
}

.stat-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 1rem;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-card-primary {
  background: #667eea;
}

.stat-card-info {
  background: #f5576c;
}

.stat-card-danger {
  background: #fa709a;
}

.stat-card .card-body {
  padding: 2rem 1rem;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.stat-label {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

@media (max-width: 576px) {
  .stat-number {
    font-size: 2rem;
  }
  
  .stat-label {
    font-size: 0.8rem;
  }
  
  .stat-card .card-body {
    padding: 1rem 1rem;
    min-height: 120px;
  }
}
</style>
